const BooksOfAccounts = {
  GeneralEntriesBook: 'general-entries',
  CashDisbursement: 'cash-disbursement',
  CashReceipt: 'cash-receipt',
  GeneralJournal: 'general-journal',
  GeneralLedger: 'general-ledger'
};

export default BooksOfAccounts;
